import React, { useEffect } from 'react';
import { useNavigate, useLocation, Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { toast } from 'sonner';
import { useTranslation } from 'react-i18next';

interface AdminRouteProps {
    children: React.ReactNode;
}

const AdminRoute: React.FC<AdminRouteProps> = ({ children }) => {
    const { t } = useTranslation();
    const { user, userRole, loading, sessionInitialized } = useAuth();
    const location = useLocation();

    useEffect(() => {
        if (!loading && sessionInitialized && user && userRole !== 'admin') {
            toast.error(t('adminRoute.access_denied', 'Acceso denegado: Área reservada para administradores.'), {
                position: 'bottom-center'
            });
        }
    }, [loading, userRole, sessionInitialized, user]);

    if (loading || !sessionInitialized) {
        return (
            <div className="min-h-screen bg-background-dark flex flex-col items-center justify-center">
                <div className="w-16 h-16 border-4 border-primary/20 border-t-primary rounded-full animate-spin shadow-[0_0_15px_rgba(242,127,13,0.5)]"></div>
                <p className="mt-6 text-sm font-black text-white/50 tracking-[0.3em] uppercase animate-pulse">
                    {t('adminRoute.verifying', 'Verificando Autorización...')}
                </p>
            </div>
        );
    }

    if (!user) {
        return <Navigate to="/login" state={{ from: location }} replace />;
    }

    if (userRole !== 'admin') {
        return <Navigate to="/dashboard" replace />;
    }

    return <>{children}</>;
};

export default AdminRoute;
